import { icon, Icon } from 'leaflet';
import { OsciloEstadoTipoEnum } from '@/model/oscilo';

export function getMarkerIcon(idOsciloEstadoTipo: OsciloEstadoTipoEnum): Icon {
    const prefix = import.meta.env.VITE_BASE_URL + '/img/markers';
    let iconUrl: string;
    switch (idOsciloEstadoTipo) {
        case OsciloEstadoTipoEnum.NoInicializado:
            iconUrl = "noinicializado.svg";
            break;
        case OsciloEstadoTipoEnum.Funcionando:
            iconUrl = "funcionando.svg";
            break;
        case OsciloEstadoTipoEnum.Standby:
            iconUrl = "standby.svg";
            break;
        case OsciloEstadoTipoEnum.SucesoNuevo:
            iconUrl = "sucesonuevo.svg";
            break;
        case OsciloEstadoTipoEnum.SucesoReciente:
            iconUrl = "sucesoreciente.svg";
            break;
        case OsciloEstadoTipoEnum.SucesoAntiguo:
            iconUrl = "sucesoantiguo.svg";
            break;
        case OsciloEstadoTipoEnum.Error:
            iconUrl = "error.svg";
            break;
        default:
            iconUrl = "";
            break;
    }
    iconUrl = `${prefix}/${iconUrl}`;
    return new Icon({
        iconUrl: iconUrl,
        iconSize: [32, 32], // Tamaño del icono
        // iconAnchor: [16, 32], // Punto de anclaje del icono
        // popupAnchor: [0, -32], // Punto de anclaje del popup            
    });
};